const OPTION_ID_TIMESTAMP_REGEX = /(\d{10,})$/;

const sanitizeOptionTitle = (title, fallback = "Option") => {
  const trimmed =
    typeof title === "string" ? title.trim().replace(/\s+/g, " ") : "";
  return trimmed || fallback;
};

const extractTimestampFromId = (id) => {
  if (typeof id !== "string") return null;
  const match = id.match(OPTION_ID_TIMESTAMP_REGEX);
  return match ? match[1] : null;
};

const buildOptionId = (title, existingId, fallbackTimestamp) => {
  const normalizedTitle = sanitizeOptionTitle(title);
  const timestampFromExisting = extractTimestampFromId(existingId);
  const timestamp = timestampFromExisting || fallbackTimestamp || `${Date.now()}`;
  return `${normalizedTitle} ${timestamp}`;
};

export const createOptionEntry = (title) => {
  const safeTitle = sanitizeOptionTitle(title);
  const timestamp = `${Date.now()}`;
  return {
    id: buildOptionId(safeTitle, null, timestamp),
    title: safeTitle,
  };
};

export const updateOptionTitle = (option, title, fallbackTitle = "Option") => {
  const baseOption =
    option && typeof option === "object" ? option : {};
  const safeTitle = sanitizeOptionTitle(title, fallbackTitle);
  const nextId = buildOptionId(safeTitle, baseOption.id);

  if (
    option &&
    option.title === safeTitle &&
    option.id === nextId
  ) {
    return option;
  }

  return {
    ...baseOption,
    title: safeTitle,
    id: nextId,
  };
};

export const normalizeOptionDataSource = (dataSource = []) => {
  if (!Array.isArray(dataSource)) return [];

  let changed = false;
  const normalized = dataSource.map((option, idx) => {
    const normalizedOption = updateOptionTitle(
      option,
      option?.title,
      `Option ${idx + 1}`
    );

    if (normalizedOption !== option) {
      changed = true;
    }

    return normalizedOption;
  });

  return changed ? normalized : dataSource;
};
